import React from 'react'

function NotFound() {
  return (
    <div>
      <h2>NO such Page</h2>
    </div>
  )
}

export default NotFound
